import React from "react";

const ChatHeader = ({ onLogout }) => {
  const userEmail = localStorage.getItem("userEmail") || "User";

  return (
    <header className="top-bar">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "16px",
          width: "100%",
        }}
      >
        <span style={{ color: "#5f6368", fontSize: "14px" }}>{userEmail}</span>
        <button
          onClick={onLogout}
          style={{
            padding: "8px 16px",
            background: "#ff6b35",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            transition: "background 0.2s ease",
          }}
          onMouseEnter={(e) => (e.target.style.background = "#e55a2b")}
          onMouseLeave={(e) => (e.target.style.background = "#ff6b35")}
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default ChatHeader;
